import EntitySync from "./EntitySync";
import StandsApi from "../../api/references/stands";

class StandsSync extends EntitySync {
    constructor(props) {
        super(props, 'stands', ['id', 'title', 'images', 'is_competitor', 'type_id', 'group_id', 'trade_mark_id', 'confirmed', 'deleted'])
    }

    startSync() {
        // старая база называлась brands (store brands)
        this.migrateLegacyDb('brands', 'brands').then(() => super.startSync())
    }

    async fetchData() {
        const data_ = await StandsApi.getList({
            search: '',
            page: 1,
            epp: 4000
        })

        const data = data_.data

        if (data.results) {
            return data.results
        }
    }
}

export default StandsSync
